import { CircularProgress, makeStyles, Theme } from '@freighthub/silhouette-core'
import cn from 'classnames'
import { FC } from 'react'
import { CSSTransition, TransitionGroup } from 'react-transition-group'

export const testIds = {
  wrapper: 'loader-wrapper',
}

type StyleProps = Pick<LoaderProps, 'page'>

const useStyles = makeStyles<Theme, StyleProps>((theme) => ({
  wrapper: ({ page }) => ({
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 100,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    ...(page ? { backgroundColor: theme.palette.background.default } : {}),
    position: page ? 'fixed' : 'absolute',
  }),
  inner: {
    textAlign: 'center',
  },
  loaderExit: {
    opacity: 1,
  },
  loaderExitActive: {
    opacity: 0.01,
    transition: 'opacity 600ms ease-in',
  },
}))

export type LoaderProps = {
  show: boolean
  showText?: boolean
  text?: string
  page?: boolean
  className?: string
}

export const Loader: FC<LoaderProps> = ({ show, page, text, showText, className }) => {
  const classes = useStyles({ page })
  return show ? (
    <TransitionGroup>
      <CSSTransition
        key="loader"
        classNames={{ exit: classes.loaderExit, exitActive: classes.loaderExitActive }}
        timeout={{ enter: 1, exit: 600 }}
      >
        <div data-testid={testIds.wrapper} className={cn(classes.wrapper, className)}>
          <div className={classes.inner}>
            <CircularProgress label={showText ? text : ''} />
          </div>
        </div>
      </CSSTransition>
    </TransitionGroup>
  ) : null
}
